<template lang="html">
  <div ref="main" class="main main-table" v-bind:class="{ printVersion: printVersion }">
    <el-row :gutter="20">
      <el-col :span="24">
        <el-main class="list-container" v-bind:class="{ ceropadding:ceropadding }">
          <el-table empty-text="Sin información" id="tableElement" ref="tableElement" v-bind:class="{ distribution_per_sector: distribution_styles, 'clickableCell': isClickable }"
          v-bind:data="tableData" @cell-click="goAsssetDetail" :default-expand-all="displayExpanded">
            <!-- Special column -->
            <el-table-column v-if="distribution_styles" v-bind:label="'Sector'">
              <template slot-scope="scope">
                <div class="TableData-wrapper">
                  <img :src="`/static/sector-icons/icon-${scope.row.name}.svg`" alt="">
                  <p class="specialText"> {{ scope.row.name }} </p>
                </div>
              </template>
            </el-table-column>
            <!-- BasicText column -->
            <el-table-column v-for="( item , index ) in titles" :key="index" v-bind:prop="item.prop" v-bind:label="item.label">
              <template slot-scope="scope">
                <p v-bind:class="modifyClass(scope.row,item.prop)"> {{ modifyData(scope.row,item.prop) }} </p>
              </template>
            </el-table-column>
            <!-- Subtotal column -->
            <el-table-column v-if="showSubtotal" :label="percentageLabel" v-bind:min-width="subtotalWidth">
              <template slot-scope="scope">
                <percentageBar ref="percentageBar" v-bind:data="scope.row.percentage"  v-bind:second-color="new_color" :third-color="scope.row.color">
                </percentageBar> <!-- v-bind:second-color="scope.row.color" -->
              </template>
            </el-table-column>
            <!--BasicText column two-->
            <el-table-column v-for="( item2 ) in titles2" :key="item2.label" v-bind:prop="item2.prop" v-bind:label="item2.label">
              <template slot-scope="scope">
                <p v-bind:class="modifyClass(scope.row,item2.prop)"> {{ modifyData(scope.row,item2.prop) }} </p>
              </template>
            </el-table-column>
            <!-- ExtraData column -->
            <el-table-column type="expand" v-if="showExtraData">
              <template slot-scope="scope">
                <p class="font-weight-600 extra-data-p">Titulos:
                  <span class="font-weight-200" style="margin-left:70px;"> {{ scope.row.securities }} </span>
                </p>
                <p class="font-weight-600 extra-data-p">Tipo de emisor:
                  <span class="font-weight-200" style="margin-left:15px;"> {{ scope.row.assetType }} </span>
                </p>
                <div v-if="scope.row.rateType">
                  <p class="font-weight-600 extra-data-p">Tipo de tasa:
                    <span class="font-weight-200" style="margin-left:34px;"> {{ scope.row.rateType }} </span>
                  </p>
                </div>
                <div v-if="scope.row.score">
                  <p class="font-weight-600 specialSliderTittle" style="margin-bottom:4px;" >Calificación:</p>
                  <template>
                    <div class="extra-data__special-slider">
                      <!-- <p class="extra-data__special-slider_text-one"> {{ scope.row.nombreDeCalificacion }} </p> -->
                      <special-slider class="special-slider" v-bind:smallThermometer="true" v-bind:graph_data="scope.row.sliderValue"
                      v-bind:calification_name="scope.row.score">
                      </special-slider>
                    </div>
                  </template>
                </div>
              </template>
            </el-table-column>
            <!-- Second ExtraData column  -->
            <el-table-column type="expand" v-if="showExtraDataTwo">
              <template slot-scope="scope">
                <p class="font-weight-600 extra-data-p">
                  Titulos:
                  <span class="font-weight-200" style="margin-left:90px;"> {{ scope.row.securities }} </span>
                </p>
                <p class="font-weight-600 extra-data-p">Nombre Completo:
                  <span class="font-weight-200" style="margin-left:10px;"> {{ scope.row.completeName }} </span>
                </p>
                <p class="font-weight-600 extra-data-p">Tipo de emisor:
                  <span class="font-weight-200" style="margin-left:35px;"> {{ scope.row.assetType }} </span>
                </p>
                <p class="font-weight-600 extra-data-p">Sector:
                  <span class="font-weight-200" style="margin-left:91px;"> {{ scope.row.sector }} </span>
                </p>
                <p ref="BursatibilityText" class="font-weight-600 bursatilidad-position">Bursatilidad:</p>
                <template>
                  <levels-indicator v-on:hideText="hideText" v-bind:graph_data="scope.row.bursatility" style="width: calc(100% - 110px);
                  display:inline-block; position:relative; top:10px;"></levels-indicator>
                </template>
              </template>
            </el-table-column>
            <!-- Third ExtraData column -->
            <el-table-column type="expand" v-if="showExtraDataThree">
              <template slot-scope="scope">
                <div class="extra-data-three">
                  <el-row type="flex" justify="left">
                    <el-col :span="1" class="extra-data-three__table-section">
                      <el-row :gutter="20">
                        <el-col :span="4">
                          <p class="font-weight-600">Títulos:</p>
                        </el-col>
                        <el-col :span="8" >
                          <p> {{ modifyTitulos(scope.row.securities) }} </p>
                        </el-col>
                        <el-col :span="4">
                          <p class="font-weight-600">Precio:</p>
                        </el-col>
                        <el-col :span="8">
                          <p> {{ modifyPrecio(scope.row.price) }} </p>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-row>
                  <div class="extra-data-three__table-section">
                  <div class="extra-data-three__table-section__header font-weight-600">
                    <el-row :gutter="20">
                      <el-col :span="11">
                          Instrumento
                      </el-col>
                      <el-col :span="10">
                          Tipo de inversión
                      </el-col>
                      <el-col :span="3">
                          %
                      </el-col>
                    </el-row>
                  </div>
                  <div class="extra-data-three__table-section__data"
                  v-for="( element, index ) in scope.row.instrumentComposition" :key="index">
                    <el-row :gutter="20">
                      <el-col :span="11">
                        {{ element.name }}
                      </el-col>
                      <el-col :span="10">
                        {{ element.inversionType.name }}
                      </el-col>
                      <el-col :span="3">
                        {{ modifyPercentage(element.percentage) }}
                      </el-col>
                    </el-row>
                  </div>
                  </div>
                  <div v-if="currentAssetClass === 'fondosrf'" class="fondosRF-score-container">
                    <p class="font-weight-600" style="margin-bottom:4px;">Calificación:</p>
                    <template>
                      <div class="extra-data__special-slider">
                        <!-- <p class="extra-data__special-slider_text-one"> {{ scope.row.nombreDeCalificacion }} </p> -->
                        <special-slider class="special-slider" v-bind:smallThermometer="true" v-bind:graph_data="scope.row.sliderValue"
                        v-bind:calification_name="scope.row.score">
                        </special-slider>
                      </div>
                    </template>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </el-main>
        <div v-if="!printVersion" style="height:38px;" >
          <ul ref="percentage_nodes" v-if="showSubtotalPercentages">
            <li v-for="( item, index ) in percentages" :key="index">
              <span style="float:left"></span>
              {{ item }}
            </li>
          </ul>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import percentageBar from "./PercentageBar";
import specialSlider from "./SpecialSlider";
import levelsIndicator from "./LevelsIndicator";
export default {
  components: {
    percentageBar: percentageBar,
    specialSlider: specialSlider,
    levelsIndicator: levelsIndicator
  },
  props: {
    graph_data: Object,
    percentage_color: String,
    show_percentage_measurer: false,
    currentAssetClass: "",
    isClickable: false,
    displayExpanded: false,
    printableVersion: false
  },
  watch: {
    graph_data: function(value) {
      this.tableData = value.data;
      this.titles = value.titles
      if (value.percentage || value.distributionPerSector) {
        this.showSubtotal = true;
      }
      if (value.displayTotalLabel) {
        this.percentageLabel = 'Total'
      }
      this.arragePercentageBar();
    }
  },
  methods: {
    goAsssetDetail(row, column, cell, event) {
      if (this.isClickable) {
        const assetName = row.assetName;
        const portfolioId = this.$route.params.id;
        const routeName = `AssetDetail_${this.currentAssetClass}`;
        this.$router.push({
          name: routeName,
          params: { id: portfolioId, assetName }
        });
      }
    },
    arragePercentageBar() {
      let self = this;
      setTimeout(function() {
        let node = self.$refs.percentageBar;
        if (!node || node == undefined) {
          return;
        }
        let nodeSize = node.$el.querySelector("#mainBar");
        if (self.showSubtotalPercentages) {
          self.$refs.percentage_nodes.style.width = nodeSize.offsetWidth + "px";
        }

        let position = nodeSize.getBoundingClientRect().left;
        let mainNode = self.$refs.main.getBoundingClientRect().left;
        let finalPosition = position - mainNode;
        if (self.showSubtotalPercentages) {
          self.$refs.percentage_nodes.style.left = finalPosition + 11 + "px";
          self.$refs.percentage_nodes.querySelector("li").firstChild.innerHTML =
            "0";
        }
      }, 100);
    },
    hideText() {
      this.$refs.BursatibilityText.style.display = "none";
    },
    modifyClass(object, keyValue) {
      let value = object[keyValue];
      let valueType = typeof value;
      if (valueType == "number") {
        if (value < 0) {
          return "red-text";
        }
      }
    },
    modifyData(object, keyValue) {
      let value = object[keyValue];
      if (value) {
        if (keyValue == "price" || keyValue == "amount" || keyValue == "currentPrice" ||  keyValue == "initialPrice" ) {
          value = "$" + value.toLocaleString();
        } else if (
          keyValue.includes("Yield") ||
          keyValue == "commission" ||
          keyValue.includes("year") ||
          keyValue == "percentage"
        ) {
          value = (value * 1000)/10;
          if (value % 1 !== 0) {
            let num = value;
            num = num.toFixed(2);
            value = Number(num);
            value = value.toFixed(2) + "%";
          } else {
            value = value.toFixed(2) + "%";
          }
        }
        return value;
      }
    },
    modifyPrecio(keyValue) {
      return "$" + keyValue.toLocaleString();
    },
    modifyTitulos(keyValue) {
      return keyValue.toLocaleString();
    },
    modifyPercentage(keyValue) {
      keyValue = keyValue * 1000 / 10;
      if (keyValue % 1 != 0) {
        let num = keyValue;
        num = num.toFixed(2);
        keyValue = Number(num);
      }
      return keyValue.toFixed(2) + "%";
    }
  },
  mounted() {
    this.tableData = this.graph_data.data;
    this.titles = this.graph_data.titles;
    this.titles2 = this.graph_data.titles2;
    if (this.percentage_color != undefined) {
      this.new_color = this.percentage_color;
    }
    if (this.graph_data.percentage || this.graph_data.distributionPerSector) {
      this.showSubtotal = true;
    }
    if (this.show_percentage_measurer == true) {
      this.showSubtotalPercentages = true;
    }
    if (this.graph_data.distributionPerSector) {
      this.distribution_styles = true;
      this.tableData = this.graph_data.data;
      this.subtotalWidth = 160;
    }
    if (this.graph_data.extraData) {
      this.showExtraData = true;
    }
    if (this.graph_data.extraDataTwo) {
      this.showExtraDataTwo = true;
    }
    if (this.graph_data.extraDataThree) {
      this.showExtraDataThree = true;
      this.ceropadding = true;
    }
    if (this.printableVersion == true) {
      this.printVersion = true;
    }

    this.arragePercentageBar();
  },
  data() {
    return {
      printVersion: false,
      red: true,
      new_color: String,
      showSubtotal: false,
      showExtraData: false,
      showExtraDataTwo: false,
      showExtraDataThree: false,
      distribution_styles: false,
      showSubtotalPercentages: false,
      ceropadding: false,
      subtotalWidth: 0,
      tableData: [],
      titles: [],
      titles2: [],
      percentageLabel: '% Subtotal',
      imageX: "static/open-arrow.svg",
      percentages: ["25%", "50%", "75%", "100%"],
      sliderData: {
        value: 0.1,
        items: [
          {
            percentage: "0%",
            name: "CCC"
          },
          {
            percentage: "0%",
            name: "B"
          },
          {
            percentage: "0%",
            name: "BB"
          },
          {
            percentage: "0%",
            name: "BBB"
          },
          {
            percentage: "0%",
            name: "A"
          },
          {
            percentage: "0%",
            name: "AA"
          },
          {
            percentage: "100%",
            name: "AAA"
          }
        ]
      }
    };
  },
  computed: {}
};
</script>

<style lang="css">
.el-table__expand-icon {
  font-size: 16px;
  color: #001f5c;
}

.el-table__expand-icon>.el-icon {
  font-weight: 700;
}

#tableElement .has-gutter {
  color: #001f5c !important;
}

#tableElement .el-table__row {
  height: 60px;
  max-height: 60px;
}

#tableElement .cell {
  line-height: 14px;
  font-size: 12px;
  word-break: break-word;
}

.distribution_per_sector .cell {
  color: #4a4a4a;
}

#tableElement .el-table__expanded-cell[class*="cell"] {
  font-size: 14px;
  line-height: 20px;
}

.clickableCell {
  cursor: pointer;
}

#tableElement .el-row {
  page-break-inside: auto;
}
#tableElement .el-col {
  page-break-inside: auto;
}

.main-table .el-row {
   page-break-inside: auto !important;
}

.main-table .el-col {
   page-break-inside: auto !important;
}
/* v-bind added */

.ceropadding .el-table__expanded-cell[class*="cell"] {
  padding: 0px;
}
</style>

<style lang="css" scoped>
.list-container .el-table__expanded-cell p {
  margin: 12px;
}

.extra-data-three {
  padding-top: 1em;
  padding-bottom: 1em;
  font-size: 14px;
}

.extra-data-three__border {
  width: 100%;
  /* border-bottom: #E3ECFF solid 1px; */
}

.extra-data-three__text-section {
  width: 350px;
  margin-bottom: 0.5em;
  /* border-bottom: #E3ECFF solid 1px; */
}

.extra-data-three__table-section {
  width: 100%;
  height: 100%;
  background-color: white;
  margin: 0 auto;
  max-width: 560px;
  overflow-y: auto;
}

.extra-data-three__table-section .el-row {
  margin-left: 0 !important;
  margin-right: 0 !important;
  padding-top: 1.1em;
  padding-bottom: 1.1em;
  border-bottom: 1px dashed #e3ecff;
  text-align: left;
}

.extra-data-three__table-section__header {
}

.extra-data-three__table-section__data {
}

.extra-data-three__text-section p {
  margin-bottom: 2px !important;
}

.red-text {
  color: red;
}

.bursatilidad-position {
  margin: 0px 8px 4px 12px !important;
  display: inline-block;
  position: relative;
  bottom: 34px;
}

.extra-data-p {
  padding-bottom: 10px;
  border-bottom: 1px dashed #e3ecff;
  margin-right: 0px !important;
}

.font-weight-600 {
  font-weight: 600;
}

.font-weight-200 {
  font-weight: 200;
}

.special-slider {
  position: relative;
  bottom: 12px;
}

.extra-data__special-slider {
  position: relative;
  bottom: 19px;
  left: 29px;
}

.extra-data__special-slider_text-one {
  position: relative;
  top: 4px;
}

.extra-data__special-slider p {
  display: inline-block;
  float: left;
  margin: 0 !important;
  margin-left: 12px !important;
  margin-top: 2px !important;
}

.table-data__open-icon {
  width: 15px;
  height: 15px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.table-data__open-icon:hover {
  cursor: pointer;
}

.TableData-wrapper {
  position: relative;
  top: 6px;
  color: #001f5c;
  height: 60px;
}

img {
  width: 25px;
  height: 25px;
}

.especialName {
  display: inline-block;
  margin-top: 10px;
  position: absolute;
  bottom: 15px;
  left: 40px;
  max-width: 130px;
}

.specialText {
  display: inline-block;
  white-space: normal;
  max-width: 170px;
  word-break: break-word;
  position: absolute;
  top: -2px;
  left: 40px;
  font-size: 14px;
  margin: 0px;
  line-height: 14px;
}

ul {
  display: block;
  list-style-type: none;
  margin: 12px 0;
  padding: 0;
  overflow: hidden;
  color: #848484;
  width: 74.7%;
  position: absolute;
  margin-bottom: 2em;
}

li {
  float: left;
  width: 25%;
  text-align: right;
  font-size: 8px;
  font-weight: 500;
  margin: 2px 0;
}

li a {
  display: block;
  padding: 8px;
}

a {
  text-decoration: none;
}

p {
  margin: 0px;
}

.main-table {
  display: block;
  margin: 0 auto;
  max-width: 720px;
  margin-bottom: 2em;
  margin-top: 2em;
}

.el-table {
  width: 720px;
  display: block;
  margin: auto;
  padding: 0;
  font-size: 14px;
  text-align: left;
}

.el-main {
  line-height: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0;
}

.fondosRF-score-container {
  width: 80%;
  margin: auto;
}
</style>
<style>
/* For the print version */

.printVersion .main-table {
  max-width: 100%;
  margin-top: 0px;
  margin-bottom: 6px;
  padding-top: 0em;
  padding-bottom: 0em;
}

.printVersion #tableElement .el-table__row {
  height: auto !important;
}

.printVersion .el-table {
  width: 100% !important;
}

.printVersion .el-table td {
  padding: 6px !important;
}

.printVersion .el-row {
  margin-left: 0 !important;
  margin-right: 0 !important;
  width: 100%;
}
</style>




// WEBPACK FOOTER //
// src/components/TableData.vue